// All UI strings for smartxglass — keep in sync across languages
export const TRANSLATIONS = {
  fr: {
    nav: { film: "Le Film", configure: "Configurer", gallery: "Galerie", specs: "Caractéristiques", faq: "FAQ", contact: "Contact", cart: "Panier" },
    hero: {
      tagline: "Maison suisse · 10 ans d'expérience · Genève",
      title1: "Le verre",
      title2: "qui se",
      title3: "dévoile",
      title4: "à la demande.",
      desc: "Le Film dépoli à cristaux liquides {brand} transforme, d'une simple impulsion électrique, vos parois vitrées en un voile dépoli — ou en transparence absolue. Une technologie d'exception, pour une intimité orchestrée.",
      ctaConfigure: "Configurer mon film",
      ctaContact: "Nous contacter",
      stats: { reaction: "Réaction", light: "Lumière", lifespan: "Durée de vie" },
      badgeOff: "SMART-FILM™ · Démo",
      badgeCorner: "Genève · Suisse",
      cornerDesc: "Sélection haut de gamme, découpée à vos dimensions exactes. Livraison en 3 à 4 semaines.",
    },
    showcase: {
      label: "· Démonstration ·",
      title1: "D'un simple",
      title2: "interrupteur",
      title3: ", tout change.",
      desc: "En position OFF, le film prend un aspect totalement dépoli — les molécules de cristaux liquides se dispersent et redirigent la lumière. En position ON, elles s'alignent instantanément : le verre redevient parfaitement transparent.",
      modeOn: "Mode ON · Transparent",
      modeOff: "Mode OFF · Dépoli",
      tip: "Cliquez le bouton pour basculer entre les deux modes",
      stateOn: "transparence",
      stateOff: "intimité",
      features: {
        f1: { t: "Intimité absolue", d: "Réduction du vis-à-vis instantanée" },
        f2: { t: "Lumière préservée", d: "Plus de 80% de transmission ON" },
        f3: { t: "Pose universelle", d: "Sur tout vitrage existant" },
        f4: { t: "Discret", d: "540 microns d'épaisseur" },
      },
    },
    config: {
      label: "· Configurateur ·",
      title1: "Vos dimensions,",
      title2: "sur mesure",
      desc: "Saisissez vos mesures en centimètres. Pour préciser au millimètre, utilisez une virgule (ex: {ex}). Minimum facturé : 1.00 m² par découpe.",
      important: "Important :",
      noteMargin: "prévoir 2 mm de moins que la dimension exacte du verre pour une pose confortable.",
      width: "Largeur (cm)",
      height: "Hauteur (cm)",
      qty: "Quantité",
      addCut: "Ajouter une découpe",
      transformerTitle: "Transformateur + télécommande",
      transformerHint: "1 transformateur offert avec votre commande. Chaque transformateur supplémentaire : +50 CHF.",
      extraTransformers: "Transformateurs supp.",
      shippingTitle: "Livraison offerte en Suisse",
      shippingSub: "3 à 4 semaines",
      discountInfo: "Au-delà de 10 m², bénéficiez d'une remise de -10% automatique (hors tarif Pro).",
      proSpace: "Espace professionnel",
      proCodeActive: "Code actif · 380 CHF/m²",
      proPlaceholder: "Votre code partenaire",
      proValidate: "Valider",
      proHint: "Tarif partenaire réservé aux professionnels du verre et de l'architecture",
      summary: "Récapitulatif",
      unitPrice: "Prix unitaire",
      vatIncl: "TTC",
      proTag: "· TARIF PRO",
      enterDims: "Renseignez vos dimensions",
      totalArea: "Surface totale",
      subtotalHT: "Sous-total HT",
      discountVolume: "Remise volume (-10%)",
      vat: "TVA",
      shipping: "Livraison",
      shippingFree: "Offerte",
      total: "Total TTC",
      emailPlaceholder: "votre@email.ch (facultatif)",
      checkout: "Procéder au paiement sécurisé",
      checkoutFooter: "Paiement sécurisé · TWINT · PostFinance · Cartes",
      cgvLabel1: "Je reconnais avoir pris connaissance des",
      cgvLabel2: "Conditions Générales de Vente",
      cgvLabel3: "et les accepter sans réserve.",
      cgvRequired: "Vous devez accepter les Conditions Générales de Vente avant de procéder au paiement.",
      installQuoteCta: "Besoin aussi de la pose par notre équipe ?",
      installQuoteAction: "Demander un devis",
      errorNoCuts: "Veuillez renseigner au moins une découpe valide.",
      errorPayment: "Erreur lors du paiement.",
      proActivated: "Code professionnel activé : tarif 380 CHF/m²",
    },
    specs: {
      label: "· Caractéristiques techniques ·",
      title1: "Une",
      title2: "précision",
      title3: "d'horloger.",
      desc: "Polymère haute performance, cosses électriques discrètes, transformateur et télécommande inclus. Livraison soignée en 3 à 4 semaines depuis Genève.",
      pdf: "Fiche technique PDF →",
      manual: "Notice de pose →",
      items: {
        thickness: "Épaisseur",
        maxHeight: "Hauteur max",
        maxWidth: "Largeur max",
        uv: "UV absorbé",
        ir: "IR rejeté (OFF)",
        transOn: "Transmission ON",
        transOff: "Transmission OFF",
        temp: "Température",
        voltage: "Tension",
        consumption: "Consommation",
        response: "Temps de réponse",
        lifespan: "Durée de vie",
      },
    },
    faq: {
      label: "· Questions fréquentes ·",
      title1: "Vos",
      title2: "interrogations",
      title3: ", éclaircies.",
      items: [
        { q: "Comment fonctionne le film à cristaux liquides ?", a: "En position OFF (sans courant), les molécules de cristaux liquides se dispersent et redirigent la lumière, créant un effet dépoli. En position ON, elles s'alignent grâce au courant, rendant la paroi totalement transparente. Le passage d'un état à l'autre se fait en moins de 20 millisecondes." },
        { q: "Comment poser le film ?", a: "Il s'agit d'un film statique. La pose est simple : nettoyez soigneusement le vitrage (eau claire + mini-goutte de savon), positionnez le film et maroufler petit à petit en enlevant progressivement la partie de protection. Pour les grandes surfaces, nous conseillons de faire appel à un professionnel afin d'assurer un raccordement électrique discret." },
        { q: "Puis-je commander une découpe spécifique (rond, demi-rond) ?", a: "Pour des raisons techniques liées aux cosses et à la circulation du courant, le film à cristaux liquides est uniquement disponible en carré ou rectangle, aux dimensions exactes de votre choix." },
        { q: "Le film est-il compatible avec une salle de bain ?", a: "Oui pour une vitre intérieure (entre deux pièces). Non pour une vitre donnant sur l'extérieur, l'humidité altérant la longévité du composant électronique." },
        { q: "Puis-je relier le film à un interrupteur ou à la domotique ?", a: "Oui, c'est tout à fait possible. Il suffit de faire appel à un électricien pour le raccordement à votre installation existante, ou intégrer le transformateur à votre système domotique (KNX, Loxone, etc.)." },
        { q: "Quelle est la livraison et le délai ?", a: "Livraison offerte partout en Suisse. Le film étant préparé à vos dimensions exactes, comptez 3 à 4 semaines entre la commande et la livraison." },
      ],
    },
    footer: {
      desc: "Maison suisse basée à Genève, spécialisée dans les films techniques pour vitrages d'exception. Sélection rigoureuse, livraison en 3 à 4 semaines.",
      product: "Produit", maison: "Maison", legal: "Légal",
      productLinks: { film: "Le Film SMART-FILM", config: "Configurateur", specs: "Caractéristiques", faq: "FAQ" },
      maisonLinks: { film: "Le smart film", install: "Service de pose", samples: "Échantillons", contact: "Contact" },
      legalLinks: { cgv: "CGV", privacy: "Confidentialité", cookies: "Cookies" },
      copy: "© 2026 smartxglass — Tous droits réservés · Genève, Suisse",
      payment: "TVA 8.1% · Paiement sécurisé",
    },
    contact: {
      back: "Retour",
      label: "· Contact ·",
      title1: "Parlons de votre",
      title2: "projet",
      desc: "Une question technique, un projet sur-mesure, un devis pour grande surface ? Notre équipe vous répond sous 24h ouvrées.",
      email: "E-mail", address: "Adresse", hours: "Horaires",
      addressVal: "Genève, Suisse", hoursVal: "Lun – Ven · 9h – 18h",
      reply: "Réponse garantie sous 24h ouvrées",
      name: "Nom *", emailField: "E-mail *", phone: "Téléphone", message: "Votre message *",
      msgPlaceholder: "Dimensions, quantité, type de projet…",
      submit: "Envoyer le message",
      orWriteTo: "Ou écrivez-nous à",
      sent: "Message envoyé ! Nous vous répondrons sous 24h ouvrées.",
      errorRequired: "Veuillez remplir les champs obligatoires.",
      errorSend: "Impossible d'envoyer votre message. Écrivez-nous directement à",
    },
    success: {
      verifying: "Vérification du paiement…",
      pleaseWait: "Merci de patienter quelques instants.",
      thanks1: "Merci pour votre",
      thanks2: "confiance",
      saved: "Votre commande a bien été enregistrée.",
      emailSent: "Un email de confirmation vous sera envoyé · Livraison 3 à 4 semaines",
      backHome: "Retour à l'accueil",
      expired: "Session expirée", timeout: "Délai dépassé", errorTitle: "Une erreur est survenue",
      errorDesc: "Si vous avez été débité, contactez-nous. Sinon, vous pouvez recommencer la commande.",
    },
    cancel: {
      title1: "Paiement", title2: "annulé",
      desc: "Aucun montant n'a été prélevé. Votre configuration vous attend toujours.",
      resume: "Reprendre ma commande",
    },
    gallery: {
      back: "Retour",
      label: "· Galerie ·",
      title1: "Nos films",
      title2: "en action",
      desc: "Découvrez en images l'effet du SMART-FILM dans différents environnements : bureaux, salles de réunion, résidentiel haut de gamme.",
      protected: "Vidéos protégées · © smartxglass",
      close: "Fermer",
      captions: {
        1: "Démonstration ON / OFF",
        2: "Cloison de bureau",
        3: "Application résidentielle",
        4: "Vue d'ensemble",
        5: "Effet sur grande surface",
        6: "Bureau contemporain",
        7: "Paroi vitrée moderne",
        8: "Installation grand format",
        9: "Transition fluide",
        10: "Détail du film",
        11: "Vitrine professionnelle",
        12: "Paroi intérieure",
        13: "Effet dépoli en continu",
        14: "Démonstration en atelier",
      },
    },
    seo: {
      swissBadge: "Fournisseur suisse · Genève",
      h2: {
        line1: "Film LCD / PDLC ON/OFF —",
        line2: "Film intelligent à cristaux liquides pour vitrage",
      },
      intro: "Le film LCD intelligent, aussi appelé film PDLC (Polymer Dispersed Liquid Crystal) ou Smart Film ON/OFF, est une solution innovante permettant de transformer instantanément un vitrage transparent en opaque. Grâce à la technologie à cristaux liquides, ce film commutable offre une gestion intelligente de la confidentialité, de la lumière et du design des espaces vitrés. smartxglass est votre fournisseur suisse basé à Genève.",
      supports: {
        title: "Le film s'applique sur :",
        lead: "Idéal pour les bureaux, banques, cabinets médicaux, hôtels, commerces, espaces administratifs et habitations privées :",
        items: [
          "cloisons en verre",
          "fenêtres",
          "baies vitrées",
          "vitrines",
          "guichets",
          "salles de réunion",
          "réceptions",
          "chambres d'hôtel",
        ],
      },
      features: {
        title: "Fonctionnalités du film PDLC (Smart Film)",
        items: [
          "Film intelligent ON/OFF : passage instantané de transparent à opaque",
          "Film anti-regard / anti-vision : protection contre les regards indiscrets",
          "Film commutable électrique : activation par interrupteur, télécommande ou domotique",
          "Technologie cristaux liquides (LCD / PDLC)",
          "Film adhésif pour vitrage existant (self-adhesive smart film)",
          "Film écran de projection compatible vidéoprojecteur",
          "Utilisation jour et nuit",
          "Solution moderne sans rideaux ni stores",
          "Isolation visuelle immédiate",
        ],
      },
      composition: {
        title: "Composition du film LCD (structure multicouche)",
        lead: "Le film PDLC haute qualité est composé de plusieurs couches techniques assurant performance et durabilité :",
        layers: [
          "PET Protecting Layer (couche de protection PET)",
          "Self-adhesive layer (couche adhésive pour pose directe sur vitrage)",
          "Indium Tin Oxide (ITO) coated film (film conducteur transparent)",
          "Liquid Crystal Layer (couche de cristaux liquides PDLC)",
          "Indium Tin Oxide (ITO) coated film",
          "PET Protecting Layer",
        ],
        footer: "Cette structure garantit une diffusion homogène de la lumière, une réactivité instantanée et une longue durée de vie.",
      },
      applications: {
        title: "Applications du Smart Film",
        lead: "Le film LCD intelligent est parfaitement adapté pour :",
        items: [
          "bureaux professionnels et open spaces",
          "salles de réunion vitrées",
          "cliniques, cabinets médicaux, laboratoires",
          "hôtels et chambres haut de gamme",
          "banques et institutions financières",
          "commerces et vitrines design",
          "habitations modernes (salles de bain, séparation de pièces)",
        ],
      },
      swissBlock: {
        title: "Fournisseur suisse · 10 ans d'expérience · Fabriqué et expédié depuis Genève",
        desc: "smartxglass est un fournisseur suisse de film LCD/PDLC basé à Genève, fort de 10 ans d'expérience dans le film intelligent à cristaux liquides. Sur mesure, livraison partout en Suisse en 3 à 4 semaines, à partir de 450 CHF/m² TTC.",
      },
    },

    sample: {
      label: "· Échantillon ·",
      title1: "Commandez votre",
      title2: "échantillon Smart Film",
      desc: "Recevez chez vous un échantillon fonctionnel du film intelligent LCD/PDLC, livré avec son câble et son transformateur. Branchez-le, testez l'effet ON/OFF instantané et constatez la qualité avant de passer votre commande définitive.",
      bullet1: "Échantillon fonctionnel · câble + transformateur inclus",
      bullet2: "Livraison en Suisse incluse",
      bullet3: "Testez l'effet ON/OFF avant de commander",
      priceLabel: "Prix tout compris",
      vatIncl: "TTC",
      emailPlaceholder: "votre@email.ch",
      cta: "Commander mon échantillon",
      footer: "Paiement sécurisé · TWINT · POSTFINANCE · CARTES",
      errorPayment: "Erreur lors du paiement. Veuillez réessayer.",
      imageAlt: "Échantillon Smart Film LCD/PDLC fonctionnel avec câble et transformateur",
      included: "Échantillon + Transfo",
    },

    docs: {
      label: "· Documentation technique ·",
      title1: "Fiches techniques et",
      title2: "notices de pose",
      intro: "Téléchargez les documents officiels smartxglass : fiche technique complète du film LCD/PDLC, notice de pose illustrée étape par étape et guide écrit détaillé pour une installation parfaite.",
      download: "Télécharger",
      items: {
        fiche: {
          title: "Fiche Technique — Smart Film LCD",
          desc: "Document complet : caractéristiques techniques, structure multicouche, tension, consommation (~5 W/m²), durée de vie, vitrages compatibles.",
        },
        noticeVisual: {
          title: "Notice de pose — Étapes visuelles",
          desc: "Tutoriel illustré avec les 10 étapes de pose : positionnement, fixation, marouflage de gauche à droite, retrait progressif du pelliculage.",
        },
        noticeText: {
          title: "Notice de pose — Procédure détaillée",
          desc: "Guide écrit : préparation du vitrage, positionnement du film, branchement électrique, mise en service.",
        },
      },
    },

    legal: { backHome: "Retour à l'accueil" },
    cookies: {
      title: "Nous respectons votre vie privée",
      intro: "Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et personnaliser la publicité. Vous pouvez refuser ou personnaliser à tout moment.",
      linkPrivacy: "Confidentialité",
      linkCookies: "Politique cookies",
      acceptAll: "Tout accepter",
      refuse: "Tout refuser",
      customize: "Personnaliser",
      preferencesTitle: "Préférences cookies",
      essentialTitle: "Cookies essentiels",
      essentialDesc: "Nécessaires au fonctionnement du site (langue, panier, session sécurisée). Ne peuvent pas être désactivés.",
      analyticsTitle: "Cookies analytiques",
      analyticsDesc: "Google Analytics 4 — statistiques anonymisées sur les visites et comportements pour améliorer le site.",
      marketingTitle: "Cookies marketing",
      marketingDesc: "Google Ads — mesure des performances publicitaires et affichage de publicités pertinentes.",
      required: "Requis",
      savePreferences: "Enregistrer mes préférences",
    },
    cookiesPage: {
      label: "· Cookies ·",
      title: "Politique relative aux cookies",
      intro: "Cette page décrit les cookies utilisés sur smartxglass.ch. Lors de votre premier passage, votre consentement a été recueilli via une bannière. Vous pouvez le révoquer ou le modifier à tout moment en bas de cette page.",
      rows: [
        { cat: "Essentiel", title: "sxg-lang", desc: "Mémorise votre préférence de langue (FR/EN/IT/DE). Expiration : 1 an." },
        { cat: "Essentiel", title: "sxg-consent", desc: "Mémorise vos préférences de cookies. Expiration : 12 mois." },
        { cat: "Analytique", title: "_ga, _ga_*", desc: "Google Analytics 4 — statistiques anonymisées. Expiration : jusqu'à 2 ans. Fournisseur : Google LLC (USA)." },
        { cat: "Analytique", title: "Metricool", desc: "Métricool — analyse complémentaire du trafic et performances marketing. Expiration : jusqu'à 13 mois. Fournisseur : Metricool Software SL (Espagne)." },
        { cat: "Marketing", title: "_gcl_au, _gads", desc: "Google Ads — mesure des conversions publicitaires et remarketing. Expiration : jusqu'à 13 mois." },
        { cat: "Fonctionnalité", title: "Stripe", desc: "Lors du paiement, Stripe pose des cookies pour prévenir la fraude. Fournisseur : Stripe Payments Europe (Irlande)." },
      ],
      resetIntro: "Vous pouvez modifier vos préférences de cookies à tout moment en cliquant ci-dessous. La bannière réapparaîtra.",
      resetButton: "Réinitialiser mes préférences",
    },
    privacy: {
      label: "· Confidentialité ·",
      title: "Politique de confidentialité",
      lastUpdate: "Dernière mise à jour : mai 2026",
      sections: [
        { h: "1. Responsable du traitement", p: "Luxury Signs Sàrl, sise à Genève, Suisse, est responsable du traitement de vos données personnelles. Contact : contact@smartxglass.ch" },
        { h: "2. Données collectées", p: "Nous collectons : nom et prénom, e-mail, téléphone, adresse de livraison (pour l'expédition de la commande), données de paiement (gérées par Stripe, jamais stockées) et données de navigation (via Google Analytics, avec votre consentement)." },
        { h: "3. Finalités du traitement", p: "Exécution des commandes, suivi de livraison, envoi des confirmations, support client, amélioration du site, marketing (avec votre consentement)." },
        { h: "4. Base légale", p: "Contrat (art. 31 nLPD), consentement (cookies, newsletter), intérêt légitime (sécurité, statistiques)." },
        { h: "5. Conservation", p: "Données de commande : 10 ans (obligation légale CH). Données marketing : jusqu'au retrait du consentement. Cookies analytiques : jusqu'à 2 ans." },
        { h: "6. Destinataires", p: "Stripe Payments Europe (paiements, IE), Infomaniak (hébergement e-mail, CH), Google LLC (Analytics & Ads, US — Clauses contractuelles types). Aucune cession commerciale." },
        { h: "7. Vos droits", p: "Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition au traitement. Pour exercer ces droits, écrivez à contact@smartxglass.ch (réponse sous 30 jours)." },
        { h: "8. Sécurité", p: "Chiffrement HTTPS, serveurs sécurisés (Suisse), accès restreints, audits réguliers." },
        { h: "9. Réclamation", p: "Vous avez le droit d'introduire une réclamation auprès du Préposé fédéral à la protection des données et à la transparence (PFPDT, www.edoeb.admin.ch)." },
        { h: "10. Mises à jour", p: "Cette politique peut être mise à jour. La dernière version est toujours disponible sur cette page." },
      ],
    },

    installQuote: {
      badge: "Fourniture + Pose",
      title1: "Demandez un",
      title2: "devis fourniture + pose",
      intro: "Vous souhaitez que notre équipe vienne poser le Smart Film chez vous ? Remplissez ce formulaire, nous vous recontactons sous 48h pour un devis personnalisé.",
      zone: "Suisse · France voisine",
      name: "Nom complet", email: "E-mail", phone: "Téléphone",
      addressTitle: "Adresse du chantier",
      address: "Adresse (rue + n°)", postalCode: "Code postal", city: "Ville", country: "Pays",
      projectTitle: "Détails du projet",
      surfaceType: "Type de surface",
      surfaceEstimate: "Surface estimée (m²)",
      surfaceTypes: {
        cloison_verre: "Cloison en verre", fenetre: "Fenêtre", baie_vitree: "Baie vitrée",
        vitrine: "Vitrine commerce", porte_verre: "Porte en verre",
        salle_reunion: "Salle de réunion", autre: "Autre",
      },
      photoLabel: "Photo du vitrage",
      photoPlaceholder: "Choisir une photo (facultatif)",
      photoHint: "Max 10 Mo · JPEG, PNG · nous aide à évaluer le projet",
      messageLabel: "Message complémentaire",
      messagePlaceholder: "Période de pose souhaitée, contraintes techniques, demandes particulières...",
      cta: "Demander mon devis",
      footer: "Réponse sous 48h ouvrées · Genève, Suisse",
      success: "Demande envoyée ! Réponse sous 48h.",
      successTitle: "Demande bien reçue",
      successDesc: "Merci ! Notre équipe vous recontactera sous 48h ouvrées avec votre devis personnalisé. Une confirmation a été envoyée à votre adresse e-mail.",
      error: "Erreur lors de l'envoi. Veuillez réessayer.",
      errorPhotoSize: "Photo trop volumineuse (max 10 Mo).",
    },

  },

  en: {
    nav: { film: "The Film", configure: "Configure", gallery: "Gallery", specs: "Specifications", faq: "FAQ", contact: "Contact", cart: "Cart" },
    hero: {
      tagline: "Swiss house · 10 years of expertise · Geneva",
      title1: "The glass",
      title2: "that",
      title3: "reveals itself",
      title4: "on demand.",
      desc: "The {brand} liquid-crystal frosted film transforms, with a simple electrical impulse, your glass partitions into a frosted veil — or absolute transparency. An exceptional technology, for orchestrated privacy.",
      ctaConfigure: "Configure my film",
      ctaContact: "Contact us",
      stats: { reaction: "Reaction", light: "Light", lifespan: "Lifespan" },
      badgeOff: "SMART-FILM™ · Demo",
      badgeCorner: "Geneva · Switzerland",
      cornerDesc: "Premium selection, cut to your exact dimensions. Delivery in 3 to 4 weeks.",
    },
    showcase: {
      label: "· Demonstration ·",
      title1: "With a single",
      title2: "switch",
      title3: ", everything changes.",
      desc: "In OFF mode, the film takes on a fully frosted appearance — the liquid crystal molecules disperse and redirect light. In ON mode, they align instantly: the glass becomes perfectly transparent.",
      modeOn: "ON Mode · Transparent",
      modeOff: "OFF Mode · Frosted",
      tip: "Click the button to toggle between modes",
      stateOn: "transparency",
      stateOff: "privacy",
      features: {
        f1: { t: "Absolute privacy", d: "Instant reduction of visibility" },
        f2: { t: "Light preserved", d: "Over 80% transmission in ON mode" },
        f3: { t: "Universal install", d: "On any existing glass" },
        f4: { t: "Discreet", d: "540 microns thick" },
      },
    },
    config: {
      label: "· Configurator ·",
      title1: "Your dimensions,",
      title2: "made to measure",
      desc: "Enter your measurements in centimetres. For millimetre precision, use a comma (e.g. {ex}). Minimum billed: 1.00 m² per cut.",
      important: "Important:",
      noteMargin: "allow 2 mm less than the exact glass dimension for a comfortable fit.",
      width: "Width (cm)",
      height: "Height (cm)",
      qty: "Quantity",
      addCut: "Add a cut",
      transformerTitle: "Transformer + remote",
      transformerHint: "1 transformer included with your order. Each additional transformer: +50 CHF.",
      extraTransformers: "Extra transformers",
      shippingTitle: "Free shipping in Switzerland",
      shippingSub: "3 to 4 weeks",
      discountInfo: "Above 10 m², get an automatic -10% discount (excluding Pro rate).",
      proSpace: "Trade account",
      proCodeActive: "Code active · 380 CHF/m²",
      proPlaceholder: "Your partner code",
      proValidate: "Validate",
      proHint: "Trade pricing reserved for glass and architecture professionals",
      summary: "Summary",
      unitPrice: "Unit price",
      vatIncl: "incl. VAT",
      proTag: "· PRO RATE",
      enterDims: "Enter your dimensions",
      totalArea: "Total area",
      subtotalHT: "Subtotal (excl.)",
      discountVolume: "Volume discount (-10%)",
      vat: "VAT",
      shipping: "Shipping",
      shippingFree: "Free",
      total: "Total (incl.)",
      emailPlaceholder: "your@email.ch (optional)",
      checkout: "Proceed to secure payment",
      checkoutFooter: "Secure payment · TWINT · PostFinance · Cards",
      cgvLabel1: "I acknowledge having read the",
      cgvLabel2: "Terms and Conditions of Sale",
      cgvLabel3: "and accept them without reserve.",
      cgvRequired: "You must accept the Terms and Conditions of Sale before proceeding to payment.",
      errorNoCuts: "Please provide at least one valid cut.",
      errorPayment: "Payment error.",
      proActivated: "Trade code activated: rate 380 CHF/m²",
    },
    specs: {
      label: "· Technical specifications ·",
      title1: "Watchmaker's",
      title2: "precision",
      title3: ".",
      desc: "High-performance polymer, discreet electrical lugs, transformer and remote included. Carefully delivered in 3 to 4 weeks from Geneva.",
      pdf: "Datasheet PDF →",
      manual: "Installation guide →",
      items: {
        thickness: "Thickness",
        maxHeight: "Max height",
        maxWidth: "Max width",
        uv: "UV absorbed",
        ir: "IR rejected (OFF)",
        transOn: "Transmission ON",
        transOff: "Transmission OFF",
        temp: "Temperature",
        voltage: "Voltage",
        consumption: "Consumption",
        response: "Response time",
        lifespan: "Lifespan",
      },
    },
    faq: {
      label: "· Frequently asked questions ·",
      title1: "Your",
      title2: "questions",
      title3: ", answered.",
      items: [
        { q: "How does liquid-crystal film work?", a: "In OFF mode (no current), the liquid crystal molecules disperse and redirect light, creating a frosted effect. In ON mode, they align with the current, making the partition fully transparent. The transition between states takes less than 20 milliseconds." },
        { q: "How is the film installed?", a: "This is a static film. Installation is simple: clean the glass thoroughly (clear water + a tiny drop of soap), position the film and squeegee gradually while peeling off the protective backing. For large surfaces, we recommend professional installation for a discreet electrical connection." },
        { q: "Can I order a custom shape (round, half-round)?", a: "For technical reasons related to the lugs and current flow, the liquid-crystal film is only available in square or rectangle, in the exact dimensions of your choice." },
        { q: "Is the film bathroom-compatible?", a: "Yes for an interior glass (between two rooms). No for a glass facing the outside — moisture affects the longevity of the electronic component." },
        { q: "Can I connect the film to a switch or home automation?", a: "Yes, absolutely. Simply have an electrician connect it to your existing installation, or integrate the transformer into your home automation system (KNX, Loxone, etc.)." },
        { q: "Delivery and lead time?", a: "Free delivery throughout Switzerland. As the film is prepared to your exact dimensions, allow 3 to 4 weeks between order and delivery." },
      ],
    },
    footer: {
      desc: "Swiss house based in Geneva, specialising in technical films for exceptional glazing. Rigorous selection, delivery in 3 to 4 weeks.",
      product: "Product", maison: "House", legal: "Legal",
      productLinks: { film: "The SMART-FILM", config: "Configurator", specs: "Specifications", faq: "FAQ" },
      maisonLinks: { film: "The smart film", install: "Installation service", samples: "Samples", contact: "Contact" },
      legalLinks: { cgv: "Terms", privacy: "Privacy", cookies: "Cookies" },
      copy: "© 2026 smartxglass — All rights reserved · Geneva, Switzerland",
      payment: "VAT 8.1% · Secure payment",
    },
    contact: {
      back: "Back",
      label: "· Contact ·",
      title1: "Let's talk about your",
      title2: "project",
      desc: "A technical question, a custom project, a quote for large surfaces? Our team replies within 24 business hours.",
      email: "E-mail", address: "Address", hours: "Hours",
      addressVal: "Geneva, Switzerland", hoursVal: "Mon – Fri · 9am – 6pm",
      reply: "Reply guaranteed within 24 business hours",
      name: "Name *", emailField: "E-mail *", phone: "Phone", message: "Your message *",
      msgPlaceholder: "Dimensions, quantity, project type…",
      submit: "Send message",
      orWriteTo: "Or write to us at",
      sent: "Message sent! We'll reply within 24 business hours.",
      errorRequired: "Please fill in the required fields.",
      errorSend: "Unable to send your message. Write to us directly at",
    },
    success: {
      verifying: "Verifying payment…",
      pleaseWait: "Please wait a moment.",
      thanks1: "Thank you for your",
      thanks2: "trust",
      saved: "Your order has been registered.",
      emailSent: "A confirmation email will be sent · Delivery 3 to 4 weeks",
      backHome: "Back home",
      expired: "Session expired", timeout: "Timed out", errorTitle: "An error occurred",
      errorDesc: "If you were charged, please contact us. Otherwise, you can restart the order.",
    },
    cancel: {
      title1: "Payment", title2: "cancelled",
      desc: "No amount has been charged. Your configuration is still waiting for you.",
      resume: "Resume my order",
    },
    gallery: {
      back: "Back",
      label: "· Gallery ·",
      title1: "Our films",
      title2: "in action",
      desc: "Discover the SMART-FILM effect in different environments: offices, meeting rooms, premium residential.",
      protected: "Protected videos · © smartxglass",
      close: "Close",
      captions: {
        1: "ON / OFF demonstration",
        2: "Office partition",
        3: "Residential application",
        4: "Overall view",
        5: "Large surface effect",
        6: "Contemporary office",
        7: "Modern glass wall",
        8: "Large-format installation",
        9: "Smooth transition",
        10: "Film detail",
        11: "Professional showcase",
        12: "Interior partition",
        13: "Continuous frosted effect",
        14: "Workshop demonstration",
      },
    },
    seo: {
      swissBadge: "Swiss supplier · Geneva",
      h2: {
        line1: "LCD / PDLC ON/OFF Film —",
        line2: "smart liquid-crystal film for glazing",
      },
      intro: "The smart LCD film, also called PDLC film (Polymer Dispersed Liquid Crystal) or Smart Film ON/OFF, is an innovative solution that instantly turns transparent glass into opaque. Thanks to liquid-crystal technology, this switchable film offers intelligent control of privacy, light and the design of glazed spaces. smartxglass is your Swiss supplier based in Geneva.",
      supports: {
        title: "The film can be applied to:",
        lead: "Ideal for offices, banks, medical clinics, hotels, retail, administrative areas and private homes:",
        items: [
          "glass partitions",
          "windows",
          "bay windows",
          "shop windows",
          "counters",
          "meeting rooms",
          "reception areas",
          "hotel rooms",
        ],
      },
      features: {
        title: "PDLC Film features (Smart Film)",
        items: [
          "Smart ON/OFF film: instant switch from transparent to opaque",
          "Anti-gaze / privacy film: protection against prying eyes",
          "Electric switchable film: activation via switch, remote or home automation",
          "Liquid-crystal technology (LCD / PDLC)",
          "Self-adhesive film for existing glass (self-adhesive smart film)",
          "Projection screen film, projector-compatible",
          "Day and night use",
          "Modern solution without curtains or blinds",
          "Immediate visual isolation",
        ],
      },
      composition: {
        title: "LCD film composition (multi-layer structure)",
        lead: "The high-quality PDLC film is made of several technical layers ensuring performance and durability:",
        layers: [
          "PET Protecting Layer",
          "Self-adhesive layer (for direct application on glazing)",
          "Indium Tin Oxide (ITO) coated film (transparent conductive film)",
          "Liquid Crystal Layer (PDLC)",
          "Indium Tin Oxide (ITO) coated film",
          "PET Protecting Layer",
        ],
        footer: "This structure ensures homogeneous light diffusion, instant responsiveness and a long lifespan.",
      },
      applications: {
        title: "Smart Film applications",
        lead: "The smart LCD film is perfectly suited for:",
        items: [
          "professional offices and open spaces",
          "glazed meeting rooms",
          "clinics, medical practices, laboratories",
          "hotels and luxury rooms",
          "banks and financial institutions",
          "shops and design storefronts",
          "modern homes (bathrooms, room dividers)",
        ],
      },
      swissBlock: {
        title: "Swiss supplier · 10 years of expertise · Manufactured and shipped from Geneva",
        desc: "smartxglass is a Swiss supplier of LCD/PDLC film based in Geneva, with 10 years of experience in smart liquid-crystal film. Made to measure, delivery throughout Switzerland in 3-4 weeks, from 450 CHF/m² incl. VAT.",
      },
    },

    sample: {
      label: "· Sample ·",
      title1: "Order your",
      title2: "Smart Film sample",
      desc: "Receive a functional sample of the smart LCD/PDLC film at home, shipped with its cable and transformer. Plug it in, test the instant ON/OFF effect and check the quality before placing your final order.",
      bullet1: "Functional sample · cable + transformer included",
      bullet2: "Shipping in Switzerland included",
      bullet3: "Test the ON/OFF effect before ordering",
      priceLabel: "All-inclusive price",
      vatIncl: "incl. VAT",
      emailPlaceholder: "your@email.ch",
      cta: "Order my sample",
      footer: "Secure payment · TWINT · POSTFINANCE · CARDS",
      errorPayment: "Payment error. Please try again.",
      imageAlt: "Functional Smart Film LCD/PDLC sample with cable and transformer",
      included: "Sample + Transformer",
    },

    docs: {
      label: "· Technical documentation ·",
      title1: "Datasheets and",
      title2: "installation guides",
      intro: "Download the official smartxglass documents: complete LCD/PDLC film datasheet, step-by-step illustrated installation guide and detailed written instructions for a perfect setup.",
      download: "Download",
      items: {
        fiche: {
          title: "Technical Datasheet — Smart Film LCD",
          desc: "Complete document: technical specifications, multi-layer structure, voltage, consumption (~5 W/m²), lifespan, compatible glazing.",
        },
        noticeVisual: {
          title: "Installation Guide — Visual steps",
          desc: "Illustrated tutorial with the 10 installation steps: positioning, fixation, left-to-right squeegeeing, progressive film removal.",
        },
        noticeText: {
          title: "Installation Guide — Detailed procedure",
          desc: "Written guide: glass preparation, film positioning, electrical wiring, commissioning.",
        },
      },
    },

    legal: { backHome: "Back to home" },
    cookies: {
      title: "We respect your privacy",
      intro: "We use cookies to improve your experience, analyze traffic and personalize advertising. You can refuse or customize at any time.",
      linkPrivacy: "Privacy",
      linkCookies: "Cookie policy",
      acceptAll: "Accept all",
      refuse: "Refuse all",
      customize: "Customize",
      preferencesTitle: "Cookie preferences",
      essentialTitle: "Essential cookies",
      essentialDesc: "Required for the site to function (language, cart, secure session). Cannot be disabled.",
      analyticsTitle: "Analytics cookies",
      analyticsDesc: "Google Analytics 4 — anonymized statistics on visits and behavior to improve the site.",
      marketingTitle: "Marketing cookies",
      marketingDesc: "Google Ads — measure ad performance and display relevant ads.",
      required: "Required",
      savePreferences: "Save preferences",
    },
    cookiesPage: {
      label: "· Cookies ·",
      title: "Cookie policy",
      intro: "This page describes the cookies used on smartxglass.ch. On your first visit, your consent was collected through a banner. You can revoke or modify it at any time at the bottom of this page.",
      rows: [
        { cat: "Essential", title: "sxg-lang", desc: "Stores your language preference (FR/EN/IT/DE). Expiry: 1 year." },
        { cat: "Essential", title: "sxg-consent", desc: "Stores your cookie preferences. Expiry: 12 months." },
        { cat: "Analytics", title: "_ga, _ga_*", desc: "Google Analytics 4 — anonymized statistics. Expiry: up to 2 years. Provider: Google LLC (USA)." },
        { cat: "Analytics", title: "Metricool", desc: "Metricool — complementary traffic and marketing performance analytics. Expiry: up to 13 months. Provider: Metricool Software SL (Spain)." },
        { cat: "Marketing", title: "_gcl_au, _gads", desc: "Google Ads — ad conversion measurement and remarketing. Expiry: up to 13 months." },
        { cat: "Functionality", title: "Stripe", desc: "When you check out, Stripe sets cookies to prevent fraud. Provider: Stripe Payments Europe (Ireland)." },
      ],
      resetIntro: "You can change your cookie preferences at any time by clicking below. The banner will reappear.",
      resetButton: "Reset my preferences",
    },
    privacy: {
      label: "· Privacy ·",
      title: "Privacy policy",
      lastUpdate: "Last updated: May 2026",
      sections: [
        { h: "1. Controller", p: "Luxury Signs Sàrl, based in Geneva, Switzerland, is responsible for processing your personal data. Contact: contact@smartxglass.ch" },
        { h: "2. Data collected", p: "We collect: first and last name, email, phone, shipping address (for order delivery), payment data (handled by Stripe, never stored) and browsing data (via Google Analytics, with your consent)." },
        { h: "3. Processing purposes", p: "Order fulfillment, shipping tracking, order confirmation emails, customer support, site improvement, marketing (with your consent)." },
        { h: "4. Legal basis", p: "Contract (Art. 31 FADP), consent (cookies, newsletter), legitimate interest (security, statistics)." },
        { h: "5. Retention", p: "Order data: 10 years (Swiss legal obligation). Marketing data: until consent is withdrawn. Analytics cookies: up to 2 years." },
        { h: "6. Recipients", p: "Stripe Payments Europe (payments, IE), Infomaniak (email hosting, CH), Google LLC (Analytics & Ads, US — Standard Contractual Clauses). No commercial transfer." },
        { h: "7. Your rights", p: "You have the right to access, rectify, erase, port, and object to processing. To exercise these rights, write to contact@smartxglass.ch (response within 30 days)." },
        { h: "8. Security", p: "HTTPS encryption, secure servers (Switzerland), restricted access, regular audits." },
        { h: "9. Complaint", p: "You have the right to file a complaint with the Federal Data Protection and Information Commissioner (FDPIC, www.edoeb.admin.ch)." },
        { h: "10. Updates", p: "This policy may be updated. The latest version is always available on this page." },
      ],
    },

    installQuote: {
      badge: "Supply + Installation",
      title1: "Request a",
      title2: "supply + installation quote",
      intro: "Want our team to install Smart Film on-site? Fill in this form and we'll get back to you within 48h with a personalized quote.",
      zone: "Switzerland · neighbouring France",
      name: "Full name", email: "Email", phone: "Phone",
      addressTitle: "Project address",
      address: "Address (street + number)", postalCode: "Postal code", city: "City", country: "Country",
      projectTitle: "Project details",
      surfaceType: "Surface type",
      surfaceEstimate: "Estimated surface (m²)",
      surfaceTypes: {
        cloison_verre: "Glass partition", fenetre: "Window", baie_vitree: "Bay window",
        vitrine: "Shop window", porte_verre: "Glass door",
        salle_reunion: "Meeting room", autre: "Other",
      },
      photoLabel: "Photo of the glazing",
      photoPlaceholder: "Choose a photo (optional)",
      photoHint: "Max 10 MB · JPEG, PNG · helps us assess the project",
      messageLabel: "Additional message",
      messagePlaceholder: "Preferred installation period, technical constraints, specific requests...",
      cta: "Request my quote",
      footer: "Reply within 48 business hours · Geneva, Switzerland",
      success: "Request sent! Reply within 48h.",
      successTitle: "Request received",
      successDesc: "Thank you! Our team will contact you within 48 business hours with your personalized quote. A confirmation has been sent to your email.",
      error: "Error sending. Please try again.",
      errorPhotoSize: "Photo too large (max 10 MB).",
    },

  },

  it: {
    nav: { film: "Il Film", configure: "Configura", gallery: "Galleria", specs: "Caratteristiche", faq: "FAQ", contact: "Contatti", cart: "Carrello" },
    hero: {
      tagline: "Maison svizzera · 10 anni di esperienza · Ginevra",
      title1: "Il vetro",
      title2: "che si",
      title3: "svela",
      title4: "su richiesta.",
      desc: "Il film opaco a cristalli liquidi {brand} trasforma, con un semplice impulso elettrico, le vostre pareti vetrate in un velo opaco — o in trasparenza assoluta. Una tecnologia d'eccezione, per un'intimità orchestrata.",
      ctaConfigure: "Configura il mio film",
      ctaContact: "Contattaci",
      stats: { reaction: "Reazione", light: "Luce", lifespan: "Durata" },
      badgeOff: "SMART-FILM™ · Demo",
      badgeCorner: "Ginevra · Svizzera",
      cornerDesc: "Selezione di alta gamma, tagliata alle vostre dimensioni esatte. Consegna in 3-4 settimane.",
    },
    showcase: {
      label: "· Dimostrazione ·",
      title1: "Con un semplice",
      title2: "interruttore",
      title3: ", tutto cambia.",
      desc: "In modalità OFF, il film assume un aspetto totalmente opaco — le molecole di cristalli liquidi si disperdono e reindirizzano la luce. In modalità ON, si allineano istantaneamente: il vetro torna perfettamente trasparente.",
      modeOn: "Modalità ON · Trasparente",
      modeOff: "Modalità OFF · Opaco",
      tip: "Cliccate il pulsante per passare tra le due modalità",
      stateOn: "trasparenza",
      stateOff: "intimità",
      features: {
        f1: { t: "Intimità assoluta", d: "Riduzione immediata della visibilità" },
        f2: { t: "Luce preservata", d: "Oltre l'80% di trasmissione in ON" },
        f3: { t: "Posa universale", d: "Su qualsiasi vetro esistente" },
        f4: { t: "Discreto", d: "540 micron di spessore" },
      },
    },
    config: {
      label: "· Configuratore ·",
      title1: "Le vostre dimensioni,",
      title2: "su misura",
      desc: "Inserite le misure in centimetri. Per la precisione al millimetro, usate la virgola (es. {ex}). Minimo fatturato: 1,00 m² per taglio.",
      important: "Importante:",
      noteMargin: "prevedete 2 mm in meno della dimensione esatta del vetro per una posa confortevole.",
      width: "Larghezza (cm)",
      height: "Altezza (cm)",
      qty: "Quantità",
      addCut: "Aggiungi un taglio",
      transformerTitle: "Trasformatore + telecomando",
      transformerHint: "1 trasformatore incluso con il vostro ordine. Ogni trasformatore aggiuntivo: +50 CHF.",
      extraTransformers: "Trasformatori extra",
      shippingTitle: "Spedizione gratuita in Svizzera",
      shippingSub: "3-4 settimane",
      discountInfo: "Oltre 10 m², beneficiate di uno sconto automatico del -10% (escluso tariffa Pro).",
      proSpace: "Area professionale",
      proCodeActive: "Codice attivo · 380 CHF/m²",
      proPlaceholder: "Il vostro codice partner",
      proValidate: "Convalida",
      proHint: "Tariffa partner riservata ai professionisti del vetro e dell'architettura",
      summary: "Riepilogo",
      unitPrice: "Prezzo unitario",
      vatIncl: "IVA inclusa",
      proTag: "· TARIFFA PRO",
      enterDims: "Inserite le vostre dimensioni",
      totalArea: "Superficie totale",
      subtotalHT: "Subtotale (esc. IVA)",
      discountVolume: "Sconto volume (-10%)",
      vat: "IVA",
      shipping: "Spedizione",
      shippingFree: "Gratuita",
      total: "Totale (IVA incl.)",
      emailPlaceholder: "vostra@email.ch (facoltativo)",
      checkout: "Procedi al pagamento sicuro",
      checkoutFooter: "Pagamento sicuro · TWINT · PostFinance · Carte",
      cgvLabel1: "Riconosco di aver preso visione delle",
      cgvLabel2: "Condizioni Generali di Vendita",
      cgvLabel3: "e di accettarle senza riserve.",
      cgvRequired: "Dovete accettare le Condizioni Generali di Vendita prima di procedere al pagamento.",
      errorNoCuts: "Inserite almeno un taglio valido.",
      errorPayment: "Errore durante il pagamento.",
      proActivated: "Codice professionale attivato: tariffa 380 CHF/m²",
    },
    specs: {
      label: "· Caratteristiche tecniche ·",
      title1: "Una",
      title2: "precisione",
      title3: "da orologiaio.",
      desc: "Polimero ad alte prestazioni, terminali elettrici discreti, trasformatore e telecomando inclusi. Consegna curata in 3-4 settimane da Ginevra.",
      pdf: "Scheda tecnica PDF →",
      manual: "Manuale di posa →",
      items: {
        thickness: "Spessore",
        maxHeight: "Altezza max",
        maxWidth: "Larghezza max",
        uv: "UV assorbiti",
        ir: "IR respinti (OFF)",
        transOn: "Trasmissione ON",
        transOff: "Trasmissione OFF",
        temp: "Temperatura",
        voltage: "Tensione",
        consumption: "Consumo",
        response: "Tempo di risposta",
        lifespan: "Durata di vita",
      },
    },
    faq: {
      label: "· Domande frequenti ·",
      title1: "Le vostre",
      title2: "domande",
      title3: ", chiarite.",
      items: [
        { q: "Come funziona il film a cristalli liquidi?", a: "In modalità OFF (senza corrente), le molecole di cristalli liquidi si disperdono e reindirizzano la luce, creando un effetto opaco. In modalità ON, si allineano grazie alla corrente, rendendo la parete totalmente trasparente. Il passaggio tra i due stati avviene in meno di 20 millisecondi." },
        { q: "Come si posa il film?", a: "Si tratta di un film statico. La posa è semplice: pulite accuratamente il vetro (acqua pulita + una piccolissima goccia di sapone), posizionate il film e premete progressivamente con uno spalmino togliendo poco a poco la pellicola protettiva. Per le grandi superfici, consigliamo di rivolgersi a un professionista per un collegamento elettrico discreto." },
        { q: "Posso ordinare una forma personalizzata (rotonda, semicircolare)?", a: "Per ragioni tecniche legate ai terminali e alla circolazione della corrente, il film a cristalli liquidi è disponibile solo in forma quadrata o rettangolare, nelle dimensioni esatte da voi scelte." },
        { q: "Il film è compatibile con il bagno?", a: "Sì per un vetro interno (tra due stanze). No per un vetro che dà sull'esterno: l'umidità altera la durata del componente elettronico." },
        { q: "Posso collegare il film a un interruttore o alla domotica?", a: "Sì, è del tutto possibile. Basta rivolgersi a un elettricista per il collegamento al vostro impianto esistente, oppure integrare il trasformatore al vostro sistema domotico (KNX, Loxone, ecc.)." },
        { q: "Quali sono le condizioni di consegna e i tempi?", a: "Spedizione gratuita in tutta la Svizzera. Poiché il film è preparato alle vostre dimensioni esatte, prevedete 3-4 settimane tra l'ordine e la consegna." },
      ],
    },
    footer: {
      desc: "Maison svizzera con sede a Ginevra, specializzata in film tecnici per vetrate d'eccezione. Selezione rigorosa, consegna in 3-4 settimane.",
      product: "Prodotto", maison: "Maison", legal: "Legale",
      productLinks: { film: "Il SMART-FILM", config: "Configuratore", specs: "Caratteristiche", faq: "FAQ" },
      maisonLinks: { film: "Lo smart film", install: "Servizio di posa", samples: "Campioni", contact: "Contatti" },
      legalLinks: { cgv: "Condizioni", privacy: "Privacy", cookies: "Cookie" },
      copy: "© 2026 smartxglass — Tutti i diritti riservati · Ginevra, Svizzera",
      payment: "IVA 8,1% · Pagamento sicuro",
    },
    contact: {
      back: "Indietro",
      label: "· Contatti ·",
      title1: "Parliamo del vostro",
      title2: "progetto",
      desc: "Una domanda tecnica, un progetto su misura, un preventivo per grandi superfici? Il nostro team risponde entro 24 ore lavorative.",
      email: "E-mail", address: "Indirizzo", hours: "Orari",
      addressVal: "Ginevra, Svizzera", hoursVal: "Lun – Ven · 9 – 18",
      reply: "Risposta garantita entro 24 ore lavorative",
      name: "Nome *", emailField: "E-mail *", phone: "Telefono", message: "Il vostro messaggio *",
      msgPlaceholder: "Dimensioni, quantità, tipo di progetto…",
      submit: "Invia messaggio",
      orWriteTo: "Oppure scriveteci a",
      sent: "Messaggio inviato! Risponderemo entro 24 ore lavorative.",
      errorRequired: "Compilate i campi obbligatori.",
      errorSend: "Impossibile inviare il messaggio. Scriveteci direttamente a",
    },
    success: {
      verifying: "Verifica del pagamento…",
      pleaseWait: "Vi preghiamo di attendere qualche istante.",
      thanks1: "Grazie per la vostra",
      thanks2: "fiducia",
      saved: "Il vostro ordine è stato registrato.",
      emailSent: "Riceverete un'email di conferma · Consegna 3-4 settimane",
      backHome: "Torna alla home",
      expired: "Sessione scaduta", timeout: "Tempo scaduto", errorTitle: "Si è verificato un errore",
      errorDesc: "Se vi è stato addebitato l'importo, contattateci. Altrimenti, potete riavviare l'ordine.",
    },
    cancel: {
      title1: "Pagamento", title2: "annullato",
      desc: "Non è stato addebitato alcun importo. La vostra configurazione è ancora salvata.",
      resume: "Riprendi l'ordine",
    },
    gallery: {
      back: "Indietro",
      label: "· Galleria ·",
      title1: "I nostri film",
      title2: "in azione",
      desc: "Scoprite in immagini l'effetto del SMART-FILM in diversi ambienti: uffici, sale riunioni, residenziale di lusso.",
      protected: "Video protetti · © smartxglass",
      close: "Chiudi",
      captions: {
        1: "Dimostrazione ON / OFF",
        2: "Parete divisoria d'ufficio",
        3: "Applicazione residenziale",
        4: "Vista d'insieme",
        5: "Effetto su grande superficie",
        6: "Ufficio contemporaneo",
        7: "Parete vetrata moderna",
        8: "Installazione grande formato",
        9: "Transizione fluida",
        10: "Dettaglio del film",
        11: "Vetrina professionale",
        12: "Parete interna",
        13: "Effetto opaco continuo",
        14: "Dimostrazione in officina",
      },
    },
    seo: {
      swissBadge: "Fornitore svizzero · Ginevra",
      h2: {
        line1: "Film LCD / PDLC ON/OFF —",
        line2: "film intelligente a cristalli liquidi per vetri",
      },
      intro: "Il film LCD intelligente, chiamato anche film PDLC (Polymer Dispersed Liquid Crystal) o Smart Film ON/OFF, è una soluzione innovativa che permette di trasformare istantaneamente un vetro trasparente in opaco. Grazie alla tecnologia a cristalli liquidi, questo film commutabile offre una gestione intelligente della privacy, della luce e del design degli spazi vetrati. smartxglass è il vostro fornitore svizzero a Ginevra.",
      supports: {
        title: "Il film si applica su:",
        lead: "Ideale per uffici, banche, studi medici, hotel, negozi, spazi amministrativi e abitazioni private:",
        items: [
          "pareti in vetro",
          "finestre",
          "vetrate",
          "vetrine",
          "sportelli",
          "sale riunioni",
          "reception",
          "camere d'hotel",
        ],
      },
      features: {
        title: "Funzionalità del film PDLC (Smart Film)",
        items: [
          "Film intelligente ON/OFF: passaggio istantaneo da trasparente a opaco",
          "Film anti-sguardo / anti-visione: protezione dagli sguardi indiscreti",
          "Film commutabile elettrico: attivazione tramite interruttore, telecomando o domotica",
          "Tecnologia a cristalli liquidi (LCD / PDLC)",
          "Film adesivo per vetro esistente (self-adhesive smart film)",
          "Film schermo di proiezione compatibile con videoproiettore",
          "Utilizzo giorno e notte",
          "Soluzione moderna senza tende né tapparelle",
          "Isolamento visivo immediato",
        ],
      },
      composition: {
        title: "Composizione del film LCD (struttura multistrato)",
        lead: "Il film PDLC di alta qualità è composto da più strati tecnici che garantiscono prestazioni e durata:",
        layers: [
          "PET Protecting Layer (strato protettivo PET)",
          "Self-adhesive layer (strato adesivo per posa diretta sul vetro)",
          "Indium Tin Oxide (ITO) coated film (film conduttore trasparente)",
          "Liquid Crystal Layer (strato di cristalli liquidi PDLC)",
          "Indium Tin Oxide (ITO) coated film",
          "PET Protecting Layer",
        ],
        footer: "Questa struttura garantisce una diffusione omogenea della luce, una reattività istantanea e una lunga durata.",
      },
      applications: {
        title: "Applicazioni dello Smart Film",
        lead: "Il film LCD intelligente è perfettamente adatto a:",
        items: [
          "uffici professionali e open space",
          "sale riunioni vetrate",
          "cliniche, studi medici, laboratori",
          "hotel e camere di alto livello",
          "banche e istituti finanziari",
          "negozi e vetrine di design",
          "abitazioni moderne (bagni, separazioni di stanze)",
        ],
      },
      swissBlock: {
        title: "Fornitore svizzero · 10 anni di esperienza · Prodotto e spedito da Ginevra",
        desc: "smartxglass è un fornitore svizzero di film LCD/PDLC con sede a Ginevra, forte di 10 anni di esperienza nel film intelligente a cristalli liquidi. Su misura, consegna in tutta la Svizzera in 3-4 settimane, a partire da 450 CHF/m² IVA inclusa.",
      },
    },

    sample: {
      label: "· Campione ·",
      title1: "Ordinate il vostro",
      title2: "campione Smart Film",
      desc: "Ricevete a casa un campione funzionante del film intelligente LCD/PDLC, consegnato con il suo cavo e il suo trasformatore. Collegatelo, testate l'effetto ON/OFF istantaneo e verificate la qualità prima del vostro ordine definitivo.",
      bullet1: "Campione funzionante · cavo + trasformatore inclusi",
      bullet2: "Spedizione in Svizzera inclusa",
      bullet3: "Testate l'effetto ON/OFF prima di ordinare",
      priceLabel: "Prezzo tutto compreso",
      vatIncl: "IVA inclusa",
      emailPlaceholder: "vostra@email.ch",
      cta: "Ordinare il mio campione",
      footer: "Pagamento sicuro · TWINT · POSTFINANCE · CARTE",
      errorPayment: "Errore di pagamento. Riprovare.",
      imageAlt: "Campione Smart Film LCD/PDLC funzionante con cavo e trasformatore",
      included: "Campione + Trasfo",
    },

    docs: {
      label: "· Documentazione tecnica ·",
      title1: "Schede tecniche e",
      title2: "istruzioni di posa",
      intro: "Scaricate i documenti ufficiali smartxglass: scheda tecnica completa del film LCD/PDLC, istruzioni di posa illustrate passo dopo passo e guida scritta dettagliata per un'installazione perfetta.",
      download: "Scaricare",
      items: {
        fiche: {
          title: "Scheda tecnica — Smart Film LCD",
          desc: "Documento completo: caratteristiche tecniche, struttura multistrato, tensione, consumo (~5 W/m²), durata, vetri compatibili.",
        },
        noticeVisual: {
          title: "Istruzioni di posa — Tappe visive",
          desc: "Tutorial illustrato con le 10 tappe di posa: posizionamento, fissaggio, marouflage da sinistra a destra, rimozione progressiva della pellicola.",
        },
        noticeText: {
          title: "Istruzioni di posa — Procedura dettagliata",
          desc: "Guida scritta: preparazione del vetro, posizionamento del film, collegamento elettrico, messa in servizio.",
        },
      },
    },

    legal: { backHome: "Torna alla home" },
    cookies: {
      title: "Rispettiamo la vostra privacy",
      intro: "Utilizziamo i cookie per migliorare la vostra esperienza, analizzare il traffico e personalizzare la pubblicità. Potete rifiutare o personalizzare in qualsiasi momento.",
      linkPrivacy: "Privacy",
      linkCookies: "Politica cookie",
      acceptAll: "Accettare tutto",
      refuse: "Rifiutare tutto",
      customize: "Personalizzare",
      preferencesTitle: "Preferenze cookie",
      essentialTitle: "Cookie essenziali",
      essentialDesc: "Necessari per il funzionamento del sito (lingua, carrello, sessione sicura). Non possono essere disattivati.",
      analyticsTitle: "Cookie analitici",
      analyticsDesc: "Google Analytics 4 — statistiche anonimizzate sulle visite e i comportamenti per migliorare il sito.",
      marketingTitle: "Cookie marketing",
      marketingDesc: "Google Ads — misurazione delle prestazioni pubblicitarie e visualizzazione di annunci rilevanti.",
      required: "Necessario",
      savePreferences: "Salvare le preferenze",
    },
    cookiesPage: {
      label: "· Cookie ·",
      title: "Politica dei cookie",
      intro: "Questa pagina descrive i cookie utilizzati su smartxglass.ch. Al vostro primo passaggio, il vostro consenso è stato raccolto tramite un banner. Potete revocarlo o modificarlo in qualsiasi momento in fondo a questa pagina.",
      rows: [
        { cat: "Essenziale", title: "sxg-lang", desc: "Memorizza la vostra preferenza linguistica (FR/EN/IT/DE). Scadenza: 1 anno." },
        { cat: "Essenziale", title: "sxg-consent", desc: "Memorizza le vostre preferenze cookie. Scadenza: 12 mesi." },
        { cat: "Analitico", title: "_ga, _ga_*", desc: "Google Analytics 4 — statistiche anonimizzate. Scadenza: fino a 2 anni. Fornitore: Google LLC (USA)." },
        { cat: "Analitico", title: "Metricool", desc: "Metricool — analisi complementare del traffico e delle prestazioni marketing. Scadenza: fino a 13 mesi. Fornitore: Metricool Software SL (Spagna)." },
        { cat: "Marketing", title: "_gcl_au, _gads", desc: "Google Ads — misurazione delle conversioni pubblicitarie e remarketing. Scadenza: fino a 13 mesi." },
        { cat: "Funzionalità", title: "Stripe", desc: "Quando andate alla cassa, Stripe imposta cookie per prevenire le frodi. Fornitore: Stripe Payments Europe (Irlanda)." },
      ],
      resetIntro: "Potete modificare le vostre preferenze cookie in qualsiasi momento cliccando qui sotto. Il banner riapparirà.",
      resetButton: "Reimpostare le mie preferenze",
    },
    privacy: {
      label: "· Privacy ·",
      title: "Informativa sulla privacy",
      lastUpdate: "Ultimo aggiornamento: Maggio 2026",
      sections: [
        { h: "1. Titolare del trattamento", p: "Luxury Signs Sàrl, con sede a Ginevra, Svizzera, è responsabile del trattamento dei vostri dati personali. Contatto: contact@smartxglass.ch" },
        { h: "2. Dati raccolti", p: "Raccogliamo: nome e cognome, e-mail, telefono, indirizzo di consegna (per la spedizione dell'ordine), dati di pagamento (gestiti da Stripe, mai memorizzati) e dati di navigazione (tramite Google Analytics, con il vostro consenso)." },
        { h: "3. Finalità del trattamento", p: "Esecuzione degli ordini, monitoraggio della spedizione, invio di conferme, supporto clienti, miglioramento del sito, marketing (con il vostro consenso)." },
        { h: "4. Base giuridica", p: "Contratto (Art. 31 nLPD), consenso (cookie, newsletter), interesse legittimo (sicurezza, statistiche)." },
        { h: "5. Conservazione", p: "Dati degli ordini: 10 anni (obbligo legale CH). Dati di marketing: fino alla revoca del consenso. Cookie analitici: fino a 2 anni." },
        { h: "6. Destinatari", p: "Stripe Payments Europe (pagamenti, IE), Infomaniak (hosting e-mail, CH), Google LLC (Analytics & Ads, US — Clausole contrattuali tipo). Nessuna cessione commerciale." },
        { h: "7. Vostri diritti", p: "Avete diritto di accesso, rettifica, cancellazione, portabilità e opposizione al trattamento. Per esercitare questi diritti, scrivete a contact@smartxglass.ch (risposta entro 30 giorni)." },
        { h: "8. Sicurezza", p: "Crittografia HTTPS, server sicuri (Svizzera), accessi limitati, audit regolari." },
        { h: "9. Reclamo", p: "Avete il diritto di presentare reclamo all'Incaricato federale della protezione dei dati e della trasparenza (IFPDT, www.edoeb.admin.ch)." },
        { h: "10. Aggiornamenti", p: "Questa informativa può essere aggiornata. L'ultima versione è sempre disponibile su questa pagina." },
      ],
    },

    installQuote: {
      badge: "Fornitura + Posa",
      title1: "Richiedete un",
      title2: "preventivo fornitura + posa",
      intro: "Desiderate che il nostro team posi il Smart Film a casa vostra? Compilate questo modulo, vi ricontatteremo entro 48h per un preventivo personalizzato.",
      zone: "Svizzera · Francia limitrofa",
      name: "Nome completo", email: "E-mail", phone: "Telefono",
      addressTitle: "Indirizzo del cantiere",
      address: "Indirizzo (via + n.)", postalCode: "CAP", city: "Città", country: "Paese",
      projectTitle: "Dettagli del progetto",
      surfaceType: "Tipo di superficie",
      surfaceEstimate: "Superficie stimata (m²)",
      surfaceTypes: {
        cloison_verre: "Parete in vetro", fenetre: "Finestra", baie_vitree: "Vetrata",
        vitrine: "Vetrina", porte_verre: "Porta in vetro",
        salle_reunion: "Sala riunioni", autre: "Altro",
      },
      photoLabel: "Foto del vetro",
      photoPlaceholder: "Scegliere una foto (opzionale)",
      photoHint: "Max 10 MB · JPEG, PNG · ci aiuta a valutare il progetto",
      messageLabel: "Messaggio aggiuntivo",
      messagePlaceholder: "Periodo di posa, vincoli tecnici, richieste specifiche...",
      cta: "Richiedere il mio preventivo",
      footer: "Risposta entro 48 ore lavorative · Ginevra, Svizzera",
      success: "Richiesta inviata! Risposta entro 48h.",
      successTitle: "Richiesta ricevuta",
      successDesc: "Grazie! Il nostro team vi ricontatterà entro 48 ore lavorative per il vostro preventivo personalizzato. Una conferma è stata inviata al vostro indirizzo e-mail.",
      error: "Errore durante l'invio. Riprovare.",
      errorPhotoSize: "Foto troppo grande (max 10 MB).",
    },

  },

  de: {
    nav: { film: "Die Folie", configure: "Konfigurieren", specs: "Eigenschaften", faq: "FAQ", contact: "Kontakt", cart: "Warenkorb" },
    hero: {
      tagline: "Schweizer Manufaktur · 10 Jahre Erfahrung · Genf",
      title1: "Das Glas,",
      title2: "das sich auf",
      title3: "Knopfdruck",
      title4: "offenbart.",
      desc: "Die Flüssigkristall-Mattfolie {brand} verwandelt Ihre Glaswände mit einem einfachen elektrischen Impuls in einen matten Schleier — oder in absolute Transparenz. Eine aussergewöhnliche Technologie für eine inszenierte Privatsphäre.",
      ctaConfigure: "Folie konfigurieren",
      ctaContact: "Kontakt aufnehmen",
      stats: { reaction: "Reaktion", light: "Licht", lifespan: "Lebensdauer" },
      badgeOff: "SMART-FILM™ · Demo",
      badgeCorner: "Genf · Schweiz",
      cornerDesc: "Hochwertige Auswahl, exakt nach Ihren Massen zugeschnitten. Lieferung in 3 bis 4 Wochen.",
    },
    showcase: {
      label: "· Demonstration ·",
      title1: "Ein einziger",
      title2: "Schalter",
      title3: " — und alles ändert sich.",
      desc: "Im OFF-Modus erscheint die Folie vollständig matt — die Flüssigkristallmoleküle streuen das Licht. Im ON-Modus richten sie sich sofort aus: Das Glas wird wieder völlig transparent.",
      modeOn: "ON-Modus · Transparent",
      modeOff: "OFF-Modus · Matt",
      tip: "Klicken Sie auf den Knopf, um zwischen den Modi zu wechseln",
      stateOn: "Transparenz",
      stateOff: "Privatsphäre",
      features: {
        f1: { t: "Absolute Privatsphäre", d: "Sofortige Sichtreduktion" },
        f2: { t: "Licht erhalten", d: "Über 80% Transmission im ON-Modus" },
        f3: { t: "Universelle Montage", d: "Auf jedem bestehenden Glas" },
        f4: { t: "Diskret", d: "540 Mikrometer dünn" },
      },
    },
    config: {
      label: "· Konfigurator ·",
      title1: "Ihre Masse,",
      title2: "massgeschneidert",
      desc: "Geben Sie Ihre Masse in Zentimetern ein. Für millimetergenaue Angaben verwenden Sie ein Komma (z.B. {ex}). Minimaler Verrechnungsbetrag: 1,00 m² pro Zuschnitt.",
      important: "Wichtig:",
      noteMargin: "Planen Sie 2 mm weniger als das exakte Glasmass ein, damit die Montage komfortabel bleibt.",
      width: "Breite (cm)",
      height: "Höhe (cm)",
      qty: "Menge",
      addCut: "Zuschnitt hinzufügen",
      transformerTitle: "Transformator + Fernbedienung",
      transformerHint: "1 Transformator ist in Ihrer Bestellung enthalten. Jeder weitere Transformator: +50 CHF.",
      extraTransformers: "Zusätzliche Transformatoren",
      shippingTitle: "Kostenloser Versand in der Schweiz",
      shippingSub: "3 bis 4 Wochen",
      discountInfo: "Ab 10 m² profitieren Sie automatisch von -10% Rabatt (ausser Pro-Tarif).",
      proSpace: "Fachhandelsbereich",
      proCodeActive: "Code aktiv · 380 CHF/m²",
      proPlaceholder: "Ihr Partnercode",
      proValidate: "Bestätigen",
      proHint: "Sondertarif für Glas- und Architekturfachleute",
      summary: "Zusammenfassung",
      unitPrice: "Stückpreis",
      vatIncl: "inkl. MwSt.",
      proTag: "· PRO-TARIF",
      enterDims: "Geben Sie Ihre Masse ein",
      totalArea: "Gesamtfläche",
      subtotalHT: "Zwischensumme (exkl.)",
      discountVolume: "Mengenrabatt (-10%)",
      vat: "MwSt",
      shipping: "Versand",
      shippingFree: "Gratis",
      total: "Gesamt (inkl.)",
      emailPlaceholder: "ihre@email.ch (optional)",
      checkout: "Zur sicheren Zahlung",
      checkoutFooter: "Sichere Zahlung · TWINT · PostFinance · Karten",
      cgvLabel1: "Ich bestätige, die",
      cgvLabel2: "Allgemeinen Geschäftsbedingungen",
      cgvLabel3: "zur Kenntnis genommen zu haben und sie vorbehaltlos zu akzeptieren.",
      cgvRequired: "Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren, bevor Sie zur Zahlung übergehen.",
      errorNoCuts: "Bitte geben Sie mindestens einen gültigen Zuschnitt an.",
      errorPayment: "Fehler beim Zahlungsvorgang.",
      proActivated: "Fachhandelscode aktiviert: 380 CHF/m²",
    },
    specs: {
      label: "· Technische Eigenschaften ·",
      title1: "Uhrmacherische",
      title2: "Präzision",
      title3: ".",
      desc: "Hochleistungspolymer, diskrete elektrische Anschlüsse, Transformator und Fernbedienung inklusive. Sorgfältige Lieferung in 3 bis 4 Wochen ab Genf.",
      pdf: "Datenblatt PDF →",
      manual: "Montageanleitung →",
      items: {
        thickness: "Dicke",
        maxHeight: "Max. Höhe",
        maxWidth: "Max. Breite",
        uv: "UV absorbiert",
        ir: "IR abgewiesen (OFF)",
        transOn: "Transmission ON",
        transOff: "Transmission OFF",
        temp: "Temperatur",
        voltage: "Spannung",
        consumption: "Verbrauch",
        response: "Reaktionszeit",
        lifespan: "Lebensdauer",
      },
    },
    faq: {
      label: "· Häufige Fragen ·",
      title1: "Ihre",
      title2: "Fragen",
      title3: ", geklärt.",
      items: [
        { q: "Wie funktioniert die Flüssigkristallfolie?", a: "Im OFF-Modus (ohne Strom) streuen sich die Flüssigkristallmoleküle und lenken das Licht um, was einen matten Effekt erzeugt. Im ON-Modus richten sie sich durch den Strom aus, und die Wand wird vollständig transparent. Der Wechsel zwischen den Zuständen dauert weniger als 20 Millisekunden." },
        { q: "Wie wird die Folie angebracht?", a: "Es handelt sich um eine statische Folie. Die Montage ist einfach: Reinigen Sie das Glas sorgfältig (klares Wasser + ein Tropfen Seife), positionieren Sie die Folie und ziehen Sie sie schrittweise mit einem Rakel auf, während Sie die Schutzfolie nach und nach abziehen. Bei grossen Flächen empfehlen wir die Montage durch einen Fachmann für einen diskreten Stromanschluss." },
        { q: "Kann ich eine besondere Form bestellen (rund, halbrund)?", a: "Aus technischen Gründen, die mit den Anschlüssen und dem Stromfluss zusammenhängen, ist die Flüssigkristallfolie ausschliesslich in quadratischer oder rechteckiger Form in Ihren exakten Massen erhältlich." },
        { q: "Ist die Folie für Badezimmer geeignet?", a: "Ja für eine Innenscheibe (zwischen zwei Räumen). Nein für eine Aussenscheibe — Feuchtigkeit beeinträchtigt die Lebensdauer der Elektronik." },
        { q: "Kann ich die Folie an einen Schalter oder die Hausautomation anschliessen?", a: "Ja, das ist problemlos möglich. Lassen Sie einen Elektriker den Anschluss an Ihre bestehende Installation vornehmen oder integrieren Sie den Transformator in Ihr Smart-Home-System (KNX, Loxone, etc.)." },
        { q: "Wie sind Lieferung und Lieferzeit?", a: "Kostenlose Lieferung in der ganzen Schweiz. Da die Folie nach Ihren exakten Massen vorbereitet wird, rechnen Sie mit 3 bis 4 Wochen zwischen Bestellung und Lieferung." },
      ],
    },
    footer: {
      desc: "Schweizer Manufaktur mit Sitz in Genf, spezialisiert auf technische Folien für aussergewöhnliche Verglasungen. Sorgfältige Auswahl, Lieferung in 3 bis 4 Wochen.",
      product: "Produkt", maison: "Manufaktur", legal: "Rechtliches",
      productLinks: { film: "Die SMART-FILM", config: "Konfigurator", specs: "Eigenschaften", faq: "FAQ" },
      maisonLinks: { film: "Die Smart-Folie", install: "Montageservice", samples: "Muster", contact: "Kontakt" },
      legalLinks: { cgv: "AGB", privacy: "Datenschutz", cookies: "Cookies" },
      copy: "© 2026 smartxglass — Alle Rechte vorbehalten · Genf, Schweiz",
      payment: "MwSt 8,1% · Sichere Zahlung",
    },
    contact: {
      back: "Zurück",
      label: "· Kontakt ·",
      title1: "Sprechen wir über Ihr",
      title2: "Projekt",
      desc: "Eine technische Frage, ein Massprojekt, ein Angebot für grosse Flächen? Unser Team antwortet innerhalb von 24 Arbeitsstunden.",
      email: "E-Mail", address: "Adresse", hours: "Öffnungszeiten",
      addressVal: "Genf, Schweiz", hoursVal: "Mo – Fr · 9 – 18 Uhr",
      reply: "Antwort innerhalb von 24 Arbeitsstunden garantiert",
      name: "Name *", emailField: "E-Mail *", phone: "Telefon", message: "Ihre Nachricht *",
      msgPlaceholder: "Masse, Menge, Projekttyp…",
      submit: "Nachricht senden",
      orWriteTo: "Oder schreiben Sie uns an",
      sent: "Nachricht gesendet! Wir antworten innerhalb von 24 Arbeitsstunden.",
      errorRequired: "Bitte füllen Sie die Pflichtfelder aus.",
      errorSend: "Nachricht konnte nicht gesendet werden. Schreiben Sie uns direkt an",
    },
    success: {
      verifying: "Zahlung wird überprüft…",
      pleaseWait: "Bitte warten Sie einen Moment.",
      thanks1: "Vielen Dank für Ihr",
      thanks2: "Vertrauen",
      saved: "Ihre Bestellung wurde erfolgreich registriert.",
      emailSent: "Eine Bestätigungs-E-Mail folgt · Lieferung 3 bis 4 Wochen",
      backHome: "Zur Startseite",
      expired: "Sitzung abgelaufen", timeout: "Zeitüberschreitung", errorTitle: "Ein Fehler ist aufgetreten",
      errorDesc: "Falls Ihnen der Betrag belastet wurde, kontaktieren Sie uns bitte. Andernfalls können Sie die Bestellung erneut starten.",
    },
    cancel: {
      title1: "Zahlung", title2: "abgebrochen",
      desc: "Es wurde kein Betrag belastet. Ihre Konfiguration wartet weiterhin auf Sie.",
      resume: "Bestellung fortsetzen",
    },
    gallery: {
      back: "Zurück",
      label: "· Galerie ·",
      title1: "Unsere Folien",
      title2: "im Einsatz",
      desc: "Entdecken Sie den SMART-FILM-Effekt in verschiedenen Umgebungen: Büros, Besprechungsräume, hochwertige Privathaushalte.",
      protected: "Geschützte Videos · © smartxglass",
      close: "Schliessen",
      captions: {
        1: "ON / OFF-Demonstration",
        2: "Büro-Trennwand",
        3: "Wohnanwendung",
        4: "Gesamtansicht",
        5: "Effekt auf grosser Fläche",
        6: "Zeitgenössisches Büro",
        7: "Moderne Glaswand",
        8: "Grossformatige Installation",
        9: "Fliessender Übergang",
        10: "Folien-Detail",
        11: "Professionelle Vitrine",
        12: "Innentrennwand",
        13: "Durchgehender Matteffekt",
        14: "Werkstatt-Demonstration",
      },
    },
    seo: {
      swissBadge: "Schweizer Hersteller · Genf",
      h2: {
        line1: "LCD-Folie / PDLC ON/OFF —",
        line2: "intelligente Flüssigkristallfolie für Verglasungen",
      },
      intro: "Die intelligente LCD-Folie, auch PDLC-Folie (Polymer Dispersed Liquid Crystal) oder Smart Film ON/OFF genannt, ist eine innovative Lösung, die transparente Verglasungen sofort in opake Flächen verwandelt. Dank der Flüssigkristalltechnologie bietet diese schaltbare Folie eine intelligente Steuerung von Privatsphäre, Licht und Design verglaster Räume. smartxglass ist Ihr Schweizer Lieferant in Genf.",
      supports: {
        title: "Die Folie wird angebracht auf:",
        lead: "Ideal für Büros, Banken, Arztpraxen, Hotels, Geschäfte, Verwaltungsräume und private Wohnräume:",
        items: [
          "Glaswände",
          "Fenster",
          "Glasfronten",
          "Schaufenster",
          "Schalter",
          "Konferenzräume",
          "Empfangsbereiche",
          "Hotelzimmer",
        ],
      },
      features: {
        title: "Funktionen der PDLC-Folie (Smart Film)",
        items: [
          "Intelligente ON/OFF-Folie: sofortiger Wechsel von transparent zu opak",
          "Sicht- und Blickschutzfolie: Schutz vor unerwünschten Blicken",
          "Elektrisch schaltbare Folie: Aktivierung über Schalter, Fernbedienung oder Smart Home",
          "Flüssigkristalltechnologie (LCD / PDLC)",
          "Selbstklebende Folie für bestehende Verglasungen (self-adhesive smart film)",
          "Projektionsleinwand-Folie kompatibel mit Beamer",
          "Tag- und Nachtnutzung",
          "Moderne Lösung ohne Vorhänge oder Jalousien",
          "Sofortige visuelle Isolierung",
        ],
      },
      composition: {
        title: "Aufbau der LCD-Folie (Mehrschichtaufbau)",
        lead: "Die hochwertige PDLC-Folie besteht aus mehreren technischen Schichten, die Leistung und Langlebigkeit gewährleisten:",
        layers: [
          "PET Protecting Layer (PET-Schutzschicht)",
          "Self-adhesive layer (Klebeschicht für Direktmontage auf Glas)",
          "Indium Tin Oxide (ITO) coated film (transparente leitfähige Folie)",
          "Liquid Crystal Layer (PDLC-Flüssigkristallschicht)",
          "Indium Tin Oxide (ITO) coated film",
          "PET Protecting Layer",
        ],
        footer: "Dieser Aufbau garantiert eine homogene Lichtverteilung, sofortige Reaktion und eine lange Lebensdauer.",
      },
      applications: {
        title: "Anwendungen der Smart Film",
        lead: "Die intelligente LCD-Folie ist perfekt geeignet für:",
        items: [
          "Büros und Open Spaces",
          "verglaste Konferenzräume",
          "Kliniken, Arztpraxen, Labore",
          "Hotels und gehobene Zimmer",
          "Banken und Finanzinstitute",
          "Geschäfte und Designschaufenster",
          "moderne Wohnräume (Bäder, Raumtrennungen)",
        ],
      },
      swissBlock: {
        title: "Schweizer Lieferant · 10 Jahre Erfahrung · Hergestellt und versandt aus Genf",
        desc: "smartxglass ist ein in Genf ansässiger Schweizer Lieferant von LCD/PDLC-Folie mit 10 Jahren Erfahrung in intelligenten Flüssigkristallfolien. Massanfertigung, Lieferung in der gesamten Schweiz innerhalb von 3 bis 4 Wochen, ab 450 CHF/m² inkl. MwSt.",
      },
    },

    sample: {
      label: "· Muster ·",
      title1: "Bestellen Sie Ihr",
      title2: "Smart Film Muster",
      desc: "Erhalten Sie ein funktionsfähiges Muster der intelligenten LCD/PDLC-Folie nach Hause, geliefert mit Kabel und Transformator. Schliessen Sie es an, testen Sie den ON/OFF-Effekt und prüfen Sie die Qualität vor Ihrer endgültigen Bestellung.",
      bullet1: "Funktionsfähiges Muster · Kabel + Transformator inklusive",
      bullet2: "Versand in der Schweiz inklusive",
      bullet3: "Testen Sie den ON/OFF-Effekt vor der Bestellung",
      priceLabel: "Komplettpreis",
      vatIncl: "inkl. MwSt.",
      emailPlaceholder: "ihre@email.ch",
      cta: "Mein Muster bestellen",
      footer: "Sichere Zahlung · TWINT · POSTFINANCE · KARTEN",
      errorPayment: "Zahlungsfehler. Bitte versuchen Sie es erneut.",
      imageAlt: "Funktionsfähiges Smart Film LCD/PDLC-Muster mit Kabel und Transformator",
      included: "Muster + Transfo",
    },

    docs: {
      label: "· Technische Dokumentation ·",
      title1: "Datenblätter und",
      title2: "Verlegeanleitungen",
      intro: "Laden Sie die offiziellen smartxglass-Dokumente herunter: vollständiges technisches Datenblatt der LCD/PDLC-Folie, illustrierte Schritt-für-Schritt-Verlegeanleitung und detaillierte schriftliche Anleitung für eine perfekte Installation.",
      download: "Herunterladen",
      items: {
        fiche: {
          title: "Technisches Datenblatt — Smart Film LCD",
          desc: "Vollständiges Dokument: technische Eigenschaften, mehrschichtiger Aufbau, Spannung, Verbrauch (~5 W/m²), Lebensdauer, kompatible Verglasungen.",
        },
        noticeVisual: {
          title: "Verlegeanleitung — Visuelle Schritte",
          desc: "Bebildertes Tutorial mit den 10 Verlegeschritten: Positionierung, Befestigung, Marouflage von links nach rechts, fortschrittliche Folienentfernung.",
        },
        noticeText: {
          title: "Verlegeanleitung — Detailliertes Verfahren",
          desc: "Schriftliche Anleitung: Vorbereitung der Verglasung, Folienpositionierung, elektrischer Anschluss, Inbetriebnahme.",
        },
      },
    },

    legal: { backHome: "Zurück zur Startseite" },
    cookies: {
      title: "Wir respektieren Ihre Privatsphäre",
      intro: "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, das Verkehrsaufkommen zu analysieren und unsere Werbung zu personalisieren. Sie können jederzeit ablehnen oder anpassen.",
      linkPrivacy: "Datenschutz",
      linkCookies: "Cookie-Richtlinie",
      acceptAll: "Alle akzeptieren",
      refuse: "Alle ablehnen",
      customize: "Anpassen",
      preferencesTitle: "Cookie-Einstellungen",
      essentialTitle: "Notwendige Cookies",
      essentialDesc: "Erforderlich für das Funktionieren der Website (Sprachauswahl, Warenkorb, sichere Sitzung). Können nicht deaktiviert werden.",
      analyticsTitle: "Analyse-Cookies",
      analyticsDesc: "Google Analytics 4 — anonymisierte Statistiken zu Besuchen und Verhalten, um die Website zu verbessern.",
      marketingTitle: "Marketing-Cookies",
      marketingDesc: "Google Ads — Messung der Werbewirksamkeit und Anzeige relevanter Werbung.",
      required: "Notwendig",
      savePreferences: "Einstellungen speichern",
    },
    cookiesPage: {
      label: "· Cookies ·",
      title: "Cookie-Richtlinie",
      intro: "Diese Seite beschreibt die auf smartxglass.ch verwendeten Cookies. Bei Ihrem ersten Besuch wurde Ihre Zustimmung über ein Banner eingeholt. Sie können diese jederzeit unten auf dieser Seite widerrufen oder ändern.",
      rows: [
        { cat: "Notwendig", title: "sxg-lang", desc: "Speichert Ihre Sprachpräferenz (FR/EN/IT/DE). Ablauf: 1 Jahr." },
        { cat: "Notwendig", title: "sxg-consent", desc: "Speichert Ihre Cookie-Präferenzen. Ablauf: 12 Monate." },
        { cat: "Analyse", title: "_ga, _ga_*", desc: "Google Analytics 4 — anonymisierte Statistiken. Ablauf: bis zu 2 Jahre. Anbieter: Google LLC (USA)." },
        { cat: "Analyse", title: "Metricool", desc: "Metricool — ergänzende Verkehrs- und Marketing-Performance-Analyse. Ablauf: bis zu 13 Monate. Anbieter: Metricool Software SL (Spanien)." },
        { cat: "Marketing", title: "_gcl_au, _gads", desc: "Google Ads — Messung der Werbekonversion und Remarketing. Ablauf: bis zu 13 Monate." },
        { cat: "Funktionalität", title: "Stripe", desc: "Wenn Sie zur Kasse gehen, setzt Stripe Cookies zur Betrugsprävention. Anbieter: Stripe Payments Europe (Irland)." },
      ],
      resetIntro: "Sie können Ihre Cookie-Einstellungen jederzeit ändern, indem Sie unten klicken. Das Banner erscheint dann erneut.",
      resetButton: "Einstellungen zurücksetzen",
    },
    privacy: {
      label: "· Datenschutz ·",
      title: "Datenschutzerklärung",
      lastUpdate: "Zuletzt aktualisiert: Mai 2026",
      sections: [
        { h: "1. Verantwortlicher", p: "Luxury Signs Sàrl, mit Sitz in Genf, Schweiz, ist verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten. Kontakt: contact@smartxglass.ch" },
        { h: "2. Erhobene Daten", p: "Wir erheben: Name und Vorname, E-Mail, Telefon, Lieferadresse (zur Bestellungserfüllung), Zahlungsdaten (über Stripe verarbeitet, niemals gespeichert) und Browser-Daten (über Google Analytics, mit Ihrer Zustimmung)." },
        { h: "3. Verarbeitungszwecke", p: "Bestellungserfüllung, Sendungsverfolgung, Versenden von Bestellbestätigungen, Kundensupport, Verbesserung der Website, Marketing (mit Ihrer Zustimmung)." },
        { h: "4. Rechtsgrundlage", p: "Vertrag (Art. 31 nDSG), Einwilligung (Cookies, Newsletter), berechtigtes Interesse (Sicherheit, Statistiken)." },
        { h: "5. Aufbewahrung", p: "Bestelldaten: 10 Jahre (gesetzliche Verpflichtung CH). Marketing-Daten: bis zum Widerruf der Einwilligung. Analyse-Cookies: bis zu 2 Jahre." },
        { h: "6. Empfänger", p: "Stripe Payments Europe (Zahlungen, IE), Infomaniak (E-Mail-Hosting, CH), Google LLC (Analytics & Ads, US — Standardvertragsklauseln). Keine kommerzielle Weitergabe." },
        { h: "7. Ihre Rechte", p: "Sie haben das Recht auf Zugang, Berichtigung, Löschung, Datenübertragbarkeit und Widerspruch gegen die Verarbeitung. Um diese Rechte auszuüben, schreiben Sie an contact@smartxglass.ch (Antwort innerhalb von 30 Tagen)." },
        { h: "8. Sicherheit", p: "HTTPS-Verschlüsselung, sichere Server (Schweiz), eingeschränkte Zugriffe, regelmässige Audits." },
        { h: "9. Beschwerde", p: "Sie haben das Recht, eine Beschwerde beim Eidgenössischen Datenschutzbeauftragten (EDÖB, www.edoeb.admin.ch) einzureichen." },
        { h: "10. Aktualisierungen", p: "Diese Erklärung kann aktualisiert werden. Die letzte Version ist immer auf dieser Seite verfügbar." },
      ],
    },

    installQuote: {
      badge: "Lieferung + Verlegung",
      title1: "Angebot anfordern",
      title2: "Lieferung + Verlegung",
      intro: "Sie möchten, dass unser Team die Smart Film vor Ort verlegt? Füllen Sie dieses Formular aus, wir kontaktieren Sie innerhalb von 48h für ein persönliches Angebot.",
      zone: "Schweiz · benachbartes Frankreich",
      name: "Vollständiger Name", email: "E-Mail", phone: "Telefon",
      addressTitle: "Adresse der Baustelle",
      address: "Adresse (Strasse + Nr.)", postalCode: "PLZ", city: "Stadt", country: "Land",
      projectTitle: "Projektdetails",
      surfaceType: "Art der Oberfläche",
      surfaceEstimate: "Geschätzte Fläche (m²)",
      surfaceTypes: {
        cloison_verre: "Glaswand", fenetre: "Fenster", baie_vitree: "Glasfront",
        vitrine: "Schaufenster", porte_verre: "Glastür",
        salle_reunion: "Konferenzraum", autre: "Sonstiges",
      },
      photoLabel: "Foto der Verglasung",
      photoPlaceholder: "Foto auswählen (optional)",
      photoHint: "Max. 10 MB · JPEG, PNG · hilft uns bei der Bewertung des Projekts",
      messageLabel: "Zusätzliche Nachricht",
      messagePlaceholder: "Verlegezeitraum, technische Einschränkungen, besondere Wünsche...",
      cta: "Mein Angebot anfordern",
      footer: "Antwort innerhalb von 48 Werktagen · Genf, Schweiz",
      success: "Anfrage gesendet! Antwort innerhalb von 48h.",
      successTitle: "Anfrage erhalten",
      successDesc: "Vielen Dank! Unser Team wird Sie innerhalb von 48 Werktagen für Ihr persönliches Angebot zurückrufen. Eine Bestätigung wurde an Ihre E-Mail gesendet.",
      error: "Fehler beim Senden. Bitte versuchen Sie es erneut.",
      errorPhotoSize: "Foto zu gross (max. 10 MB).",
    },

  },
};

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];
